import identity from "./identity.js";
import overRest from "./_overRest.js";
import setToString from "./_setToString.js";
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + "");
}
export {
  baseRest as default
};
//# sourceMappingURL=_baseRest.js.map
